import React, { useEffect, useState } from "react";
import { Clock, Target, TrendingUp, ListChecks } from "lucide-react";
import BasicLineChart from "./BaseLineChart";
import BasicBars from "./BasicCharts";
import { useNavigate } from "react-router-dom";
import PieChartWithPaddingAngle from "./PieChart";

const SalesDashboard = () => {
  const navigate = useNavigate();
  const COMPANYCODE = localStorage.getItem("companyCode");
  const DEPARTMENT = localStorage.getItem("currentSelectedDepartment");
  const APIPATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];
  const CURRENTUSEROBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : [];
  const SALESPERSON = CURRENTUSEROBJECT[0]?.sales_man;

  const [dashboardData, setDashboardData] = useState([]);
  const [myTaskCount, setMyTaskCount] = useState([]);
  const [myTopustomers, setMyTopCustomers] = useState([]);
  const [salesOverviewGraph, setSalesOverviewGraph] = useState([]);
  const [dailySalesTrend, setDailySalesTrend] = useState([]);
  const [targetvsAchivements, setTargetvsAchivements] = useState([]);

  const [loading, setLoading] = useState(true);
  const BASE_URL = APIPATHS[0]?.API_CONFIG;

  const API_ENDPOINTS = {
    dashboard: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_MYACHIVEMENT/${SALESPERSON}/${DEPARTMENT}`,
    myTasks: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_MYTASK/${SALESPERSON}/${DEPARTMENT}`,
    topCustomers: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_MYTOPCUSTOMERS/${SALESPERSON}/${DEPARTMENT}`,
    salesOverview: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_SALESTREND/${SALESPERSON}/${DEPARTMENT}`,
    dailySales: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_DAILYSALESTREND/${SALESPERSON}/${DEPARTMENT}`,
    targetVsAchievement: `${BASE_URL}/api/CpaysCount/${COMPANYCODE}/SD_TargetvsAchivement/${SALESPERSON}/${DEPARTMENT}`,
  };

  const fetchApiData = async (url, setter, isSingleObject = false) => {
    try {
      const response = await fetch(url);
      const data = await response.json();

      if (Array.isArray(data) && data.length > 0) {
        setter(isSingleObject ? data[0] : data);
      }
    } catch (error) {
      console.error(`API failed: ${url}`, error);
    }
  };

  useEffect(() => {
    const fetchAllDashboardData = async () => {
      setLoading(true);

      await Promise.all([
        fetchApiData(API_ENDPOINTS.dashboard, setDashboardData, true),
        fetchApiData(API_ENDPOINTS.myTasks, setMyTaskCount, true),
        fetchApiData(API_ENDPOINTS.topCustomers, setMyTopCustomers),
        fetchApiData(API_ENDPOINTS.salesOverview, setSalesOverviewGraph),
        fetchApiData(API_ENDPOINTS.dailySales, setDailySalesTrend),
        fetchApiData(API_ENDPOINTS.targetVsAchievement, setTargetvsAchivements),
      ]);

      setLoading(false);
    };

    fetchAllDashboardData();
  }, []);

  const onMyTaks = () => {
    navigate("/jobs");
  };
  return (
    <>
      <style jsx global>{`
        @keyframes rotate {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(360deg);
          }
        }

        @keyframes rotate-reverse {
          from {
            transform: translate(-50%, -50%) rotate(0deg);
          }
          to {
            transform: translate(-50%, -50%) rotate(-360deg);
          }
        }

        .animate-rotate {
          animation: rotate 8s linear infinite;
        }

        .animate-rotate-reverse {
          animation: rotate-reverse 10s linear infinite;
        }
      `}</style>

      <div className="relative w-full  overflow-hidden bg-gradient-to-br from-[#e8f4ff] to-[#d9f3ff] flex items-start justify-center">
        <div className="relative  flex flex-col items-start justify-between gap-8 px-4 py-10 ">
          <h2 className="text-4xl font-semibold ml-4 text-gray-700">
            Sales Dashboard
          </h2>
          <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-5">
            <div
              onClick={onMyTaks}
              className="cursor-pointer flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8 bg-red-500"
            >
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  My Tasks
                </h2>
                <ListChecks className="w-4 h-4 text-red-600 mt-2" />
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {myTaskCount?.CNT}
                  <span className="ml-2 text-xl font-medium text-gray-500">
                    total
                  </span>
                </p>
              </div>
            </div>
            <div className="flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8">
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  My Sales
                </h2>
                <TrendingUp className="w-4 h-4 text-green-600 mt-2" />
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {dashboardData?.MySales}
                  <span className="ml-2 text-xl font-medium text-gray-500"></span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8">
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  My Target
                </h2>
                <Target className="w-4 h-4 text-blue-500 mt-2" />
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {dashboardData?.MyTarget}
                  <span className="ml-2 text-xl font-medium text-gray-500"></span>
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8">
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  My Achievement
                </h2>
                <p className="mt-1 text-sm text-gray-500 ">%</p>
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {dashboardData?.MyAchievementPerc}%
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-between rounded-3xl bg-white p-6 text-center shadow-lg sm:p-8">
              <div className="flex flex-col items-center justify-center ">
                <h2 className="text-xl font-semibold   text-gray-700 lg:text-2xl">
                  Pending to Target
                </h2>
                <Clock className="w-4 h-4 text-orange-500 text-center mt-2" />
              </div>

              <div className="mt-6">
                <p className="text-4xl font-light   text-black sm:text-5xl">
                  {dashboardData?.PendingToTarget}{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="flex gap-4 w-full">
            <div className="w-1/2 shadow-lg rounded-3xl bg-white p-4">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Daily Sales Trend (MTD)
              </h2>
              <BasicLineChart apiData={dailySalesTrend} />
            </div>
            <div className="w-1/2 shadow-lg rounded-3xl bg-white p-4">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Target vs Achivement
              </h2>
              <BasicBars apiData={targetvsAchivements} />
            </div>
          </div>
          <div className="flex justify-center items-center w-full gap-4">
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <PieChartWithPaddingAngle apiData={salesOverviewGraph} />{" "}
            </div>

            <div className="w-full shadow-lg rounded-3xl bg-white p-4 ">
              <div className="h-[336px] overflow-y-auto">
                <h2 className="text-xl font-semibold   text-gray-700 ">
                  My Top Customers
                </h2>
                {myTopustomers?.map((customer, index) => (
                  <div className="flex justify-between items-center my-2 border-b pb-2">
                    <p className="text-md text-gray-700 ">
                      {customer?.CustomerName}
                    </p>
                    <p className="text-md text-gray-700 ">
                      {customer?.NetSales}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            {/* Arc Design  */}
            {/* <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign valueFromParent={94} colorFromParent={"#52b202"} />
            </div>
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign valueFromParent={93} colorFromParent={"#E1C253"} />
            </div> */}
          </div>
          {/* <div className="flex justify-center items-center w-full gap-4">

           <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign />
            </div>
            <div className=" shadow-lg rounded-3xl bg-white p-4 w-full">
              <h2 className="text-xl font-semibold   text-gray-700 ">
                Sales Overview
              </h2>
              <ArcDesign />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SalesDashboard;
